import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@commons';
import { Campaign, GenericResponse } from '@interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { CampaignDetail } from '../../campaigns/models/campaign.models';
import { ContractDraft, ContractOrigin, RenovateContractDraft, RenovateContractSave } from '../models/renovate-contract-pymes.model';

@Injectable({
  providedIn: 'root'
})
export class RenovateContractPymesService {
  private loaderRenovateContract = new BehaviorSubject<number>(0);

  constructor(private http: HttpClient, private config: ConfigService) { }

  public getLoader(): BehaviorSubject<number> {
    return this.loaderRenovateContract;
  }

  public setLoader(plus: boolean): void {
    let activesCalls = this.loaderRenovateContract.value;
    plus ? activesCalls++ : activesCalls--;
    this.loaderRenovateContract.next(activesCalls);
  }

  public resetLoader(): void {
    this.loaderRenovateContract.next(0);
  }

  public getContractRenovate(codContrato: string): Observable<GenericResponse<ContractOrigin>> {
    return this.http.get<GenericResponse<ContractOrigin>>(this.config.getUrl('contrato.getContractRenovate', { codContrato }));
  }

  public getContractDraft(idBorrador: number): Observable<GenericResponse<ContractDraft>> {
    return this.http.get<GenericResponse<ContractDraft>>(this.config.getUrl('contrato.getDraftDetail', { idBorrador }));
  }

  public queryCifRenovate(contrato: string, params): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(this.config.getUrl('contrato.queryCifRenovate', { contrato }), {}, { params });
  }

  public renovateContractPymes(params: RenovateContractSave): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(this.config.getUrl('contrato.putRenovateContract'), params);
  }

  public renovateContractDraftPymes(idBorrador: number, params: RenovateContractDraft): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(this.config.getUrl('pymes.newContract.draft', { idBorrador }), params);
  }

  public getCampaignsFiltered(
    ContactoCRM: string,
    TarifaSips: string,
    ZonaGeograficaCUPS: string,
    Consumo: string,
    CodigoContratoARenovar: string
  ): Observable<GenericResponse<Campaign[]>> {
    const params = {
      TarifaSips,
      ZonaGeograficaCUPS,
      ContactoCRM,
      Consumo,
      CodigoContratoARenovar
    };
    return this.http.get<GenericResponse<Campaign[]>>(this.config.getUrl('maestros.getCampaigns'), { params });
  }

  public getCampaignDetail(idCampana: number | string): Observable<GenericResponse<CampaignDetail[]>> {
    return this.http.get<GenericResponse<CampaignDetail[]>>(
      this.config.getUrl('campanas.getDetallesCampana', { idCampana })
    );
  }

  public renovateContractPymesAsync(params: RenovateContractSave): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(this.config.getUrl('contrato.putRenovateContractAsync'), params);
  }

}
